<main class="team-page container">
  <section class="team-hero">
    <div class="team-hero__content">
      <h1 class="team-hero__title">
        Meet Our <span class="team-hero__title-accent">Team</span>
      </h1>
      <p class="team-hero__subtitle">{{ 'teamPage.subtitle' | translate }}</p>
      <div class="team-hero__descriptions">
        <p class="team-hero__description">
          {{ 'teamPage.description1' | translate }}
        </p>
        <p class="team-hero__description">
          {{ 'teamPage.description2' | translate }}
        </p>
      </div>
    </div>
    <span class="team-hero__divider" aria-hidden="true"></span>
  </section>

  <section
    class="team-grid"
    [attr.aria-label]="'global.team_members' | translate">
    @for (profile of teamProfiles; track profile.id) {
      <article class="team-card">
        <div class="team-card__image-wrapper">
          <img
            class="team-card__image"
            [src]="profile.image"
            [alt]="profile.imageAltKey | translate"
            width="360"
            height="300" />
        </div>
        <div class="team-card__body">
          <h2 class="team-card__name">{{ profile.nameKey | translate }}</h2>
          <p class="team-card__role">{{ profile.roleKey | translate }}</p>
          <p class="team-card__bio">{{ profile.bioKey | translate }}</p>
        </div>
      </article>
    }
  </section>
</main>
